/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_A6Inputs */

const en_to_xml_faq_a6 = /** @type {(inputs: To_Xml_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not reliably, and not with this tool. A single element and a one item array produce identical markup, and XML has no number type, so 42 and "42" are indistinguishable. Reconstructing the original JSON needs a schema that says which elements repeat and which are numeric.`)
};

const ko_to_xml_faq_a6 = /** @type {(inputs: To_Xml_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안정적으로는 할 수 없고, 이 도구로는 불가능합니다. 단일 요소와 항목 하나짜리 배열이 동일한 마크업을 만들고, XML에는 숫자 타입이 없으므로 42와 "42"를 구분할 수 없습니다. 원래 JSON을 복원하려면 어느 요소가 반복되고 어느 것이 숫자인지 알려주는 스키마가 필요합니다.`)
};

const ja_to_xml_faq_a6 = /** @type {(inputs: To_Xml_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確実にはできず、このツールでもできません。単一の要素と 1 項目の配列が同一のマークアップになり、XML には数値型がないので 42 と "42" を区別できません。元の JSON を復元するには、どの要素が繰り返しでどれが数値かを示すスキーマが必要です。`)
};

/**
* | output |
* | --- |
* | "Not reliably, and not with this tool. A single element and a one item array produce identical markup, and XML has no number type, so 42 and \"42\" are indistin..." |
*
* @param {To_Xml_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_a6 = /** @type {((inputs?: To_Xml_Faq_A6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_A6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_a6(inputs)
	if (locale === "ko") return ko_to_xml_faq_a6(inputs)
	return ja_to_xml_faq_a6(inputs)
});